import HTML from '../assets/html.svg';
import CSS from '../assets/css.svg';
import JS from '../assets/javascript.svg';
import REACT from '../assets/react.svg';
import REACTNATIVE from '../assets/react-native.svg';
import REDUX from '../assets/redux.svg';
import FIGMA from '../assets/figma.svg';
import TAILWIND from '../assets/tailwind.svg';
import NODEJS from '../assets/nodejs.svg';
import MYSQL from '../assets/mysql.svg';
import MONGODB from '../assets/mongodb.svg';
import MSCOMPLEX from '../assets/projects/mscomplex.png';
import RAWSTRENGTH from '../assets/projects/raw-strength.png';
import FINDTREND from '../assets/projects/demo-find-trend.png';

export const works = [
    {
        name: "MERN stack Ecommerce",
        img: MSCOMPLEX,
        demoSite: "https://mscomplex.onrender.com/",
        github: "https://github.com/afshoang/mscomplex-mern"
    },
    {
        name: "React Native App",
        img: RAWSTRENGTH,
        demoSite: "https://expo.dev/@hoangpham56/raw-strength",
        github: "https://github.com/afshoang/Raw-Strength-Workout-Tracker"
    },
    {
        name: "Find Trend React App",
        img: FINDTREND,
        demoSite: "https://find-trend.netlify.app/",
        github: "https://github.com/afshoang/findtrend-landing-page"
    },
]

export const skills = [
    {
        src: HTML,
        name: 'html'
    },
    {
        src: CSS,
        name: 'css'
    },
    {
        src: JS,
        name: 'javascript'
    },
    {
        src: REACT,
        name: 'react'
    },
    {
        src: REACTNATIVE,
        name: 'react-native'
    },
    {
        src: REDUX,
        name: 'redux'
    },
    {
        src: TAILWIND,
        name: 'tailwind'
    },
    {
        src: FIGMA,
        name: 'figma'
    },
    {
        src: NODEJS,
        name: 'nodejs'
    },
    {
        src: MYSQL,
        name: 'mysql'
    },
    {
        src: MONGODB,
        name: 'mongo db'
    },
]